import React from "react";
import { useAuth } from "@clerk/react";
import { Helmet } from "react-helmet";
import { hardSignOut } from "../../services/authSession";
import BrandLogo from "../../components/BrandLogo";

const AccessDenied = () => {
  const { signOut } = useAuth();

  return (
    <section className="beforeLoginSection">
      <Helmet>
        <title>Access denied</title>
      </Helmet>
      <div className="beforeLoginRow">
        <div className="beforeLoginInner">
          <BrandLogo className="logo" alt="TLK" />
          <h3>Access denied</h3>
          <p>
            This admin portal is limited to the internal team. Your account is
            signed in but is not on the allowlist.
          </p>
          <button
            className="themeBtn fullBtn"
            type="button"
            onClick={() => hardSignOut(signOut)}
          >
            Sign out
          </button>
        </div>
      </div>
    </section>
  );
};

export default AccessDenied;
